// extracted by mini-css-extract-plugin
export default {"one":"SecOne_one__BvfJ6","main":"SecOne_main__JvH4k","gif":"SecOne_gif__WJrhg"};